export default __webpack_public_path__ + "static/media/lottery-hover.169eb8e5.webp";